import {DescriptionText, H1Text, H2Text} from "../../../../design";
import React from "react";
import {AmountDivideByHundred} from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyformatter from "../../../../utils/currencyformatter";

type Props = {
  payment: Object,
  whiteLabel: Boolean,
  bankImageUrl: String,
}

const Header = (props:Props) => {
  const { payment, bankImageUrl, whiteLabel } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;
  return (
    <SmallScreenHeader paymentCheckout={true} bankImageUrl={bankImageUrl} largeLogo={largeLogo} whiteLabel={whiteLabel}>
      {/* <H1Text>
        woocommerce
      </H1Text> */}
      <H2Text>
        Payment For
      </H2Text>
      <DescriptionText>
        {payment && payment.description}
      </DescriptionText>
      <H2Text>
        Amount Payable
      </H2Text>
      <DescriptionText fontSize="24px">
        {payment ? `${currencyformatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null }
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default Header;
